import React from "react";
import { Toolbar, SaveButton } from "react-admin";

const SettingsToolbar = () => (
	<Toolbar>
		<SaveButton alwaysEnable />
	</Toolbar>
);

export default SettingsToolbar;
